import {
  Badge,
  Button,
  Checkbox,
  ConfigProvider,
  Form,
  Layout,
  List,
  Space,
  Typography,
} from "antd";
import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import file from "../components/download/authorization-form.pdf";
import { ThemeContext } from "../context/themeContext";
import CustomHeader from "../components/common/Header";

const { Title } = Typography;

const DownloadLink = () => {
  const { theme } = useContext(ThemeContext)
  return (
    <a className={`${theme}-color`} href={file} download={true} size="small">
      HIPAA Authorization
    </a>
  );
};
const data = [
  <>If you are not the patient, you will need to submit a <u><DownloadLink /></u> form (click on the link to download a blank form).</>,
  "Patient name, DOB, and address.",
  "Requester contact information.",
  "Location of care received.",
  "Recipient contact information.",
];

const Patient = () => {
  const { Content, Footer, Header } = Layout;
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate(); // Hook for navigation
  const [form] = Form.useForm();
  const onFinish = (values) => {
    navigate("/Patientdetails");
  };

  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            List: {
              fontSize: 24,
              lineWidth: "0",
            },
            Layout: {
              footerPadding: 12,
            },
          },
        }}
      >
        {" "}
        <Layout className="bg-white">
         <CustomHeader />
          <Content className="p-6 pb-0">
            <Form form={form} onFinish={onFinish}>
              <div className="container mx-auto followingl-list">
                <List
                  size="small"
                  header={
                    <Title level={3}>
                      You will need the following information to submit your request:
                    </Title>
                  }
                  footer={
                    <i className="text-base">
                      Please note: There <u>may</u> be a <u>fee</u> for
                      processing your request. If there is a fee, we will reach
                      out to <u>you</u> with the next steps.
                    </i>
                  }
                  bordered={false}
                  dataSource={data}
                  renderItem={(item) => (
                    <List.Item className="followingl-list-item">
                      <Typography.Text>
                        {" "}
                        <Badge color="black" style={{ marginTop: "-1rem" }} />
                      </Typography.Text>{" "}
                      <span>{item}</span>
                    </List.Item>
                  )}
                />
                <Form.Item
                  name="agreement"
                  valuePropName="checked"
                  rules={[
                    {
                      validator: (_, value) =>
                        value
                          ? Promise.resolve()
                          : Promise.reject(
                            new Error("Please accept the agreement.")
                          ),
                    },
                  ]}
                >
                  <Space className="w-full mb-5">
                    {" "}
                    <Checkbox className="font-medium">
                      I have <span className="highlight-color"> all </span>the
                      required information to continue to the form.
                    </Checkbox>
                  </Space>
                </Form.Item>
                <Space className="w-full mt-8 justify-between" align="baseline">
                  <Link to="/Welcome">
                    <Button type="primary">
                      Back
                    </Button>
                  </Link>
                  <Form.Item>
                    <Button
                      type="primary"
                      onClick={current === 0 ? form.submit : navigate("/Patientdetails")}
                    >
                      Continue
                    </Button>
                  </Form.Item>
                </Space>
                <Footer className="welcome-footer bg-white">
                  <img
                    className="m-auto"
                    src={window.location.origin + "/assets/images/Logo.svg"}
                  />
                </Footer>
              </div>
            </Form>
          </Content>
        </Layout>
      </ConfigProvider>
    </>
  );
};

export default Patient;
